import {tags,data}from'./data/countries.js';const e=tags;var r=data;export{e as AvailableCountriesTags,r as default};